import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../styles/Blog.css";

import { blogPosts } from "../data/blogPosts";

export default function Blog() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{`${t("blog.helmetTitle")} | Alfasol`}</title>
        <meta name="description" content={t("blog.description")} />
        <link rel="canonical" href="https://alfasol.es/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${t("blog.helmetTitle")} | Alfasol`} />
        <meta property="og:description" content={t("blog.description")} />
        <meta property="og:url" content="https://alfasol.es/blog" />
      </Helmet>

      <div className="blog-container">
        <h1>{t("blog.title")}</h1>

        <div className="blog-list">
          {blogPosts.map((post) => (
            <Link 
              key={post.id}
              to={`/blog/${post.slug}`}
              className="blog-post-link"
            >
              <article className="blog-post">
                <img
                  src={post.img}
                  alt={t(post.titleKey)}
                  className="blog-post-img"
                />

                <p className="blog-post-date">
                  <time dateTime={post.publishedTime}>
                    {t(post.dateKey)}
                  </time>
                </p>

                <div className="blog-tags">
                  {post.tags.map((tag) => (
                    <span key={tag} className="blog-tag">
                      {t(tag)}
                    </span>
                  ))}
                </div>

                <h2>{t(post.titleKey)}</h2>

                <p>{t(post.excerptKey)}</p>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}